import { NgModule } from '@angular/core';
import {
  AuthModule,
  AUTH_SERVICE,
  PUBLIC_FALLBACK_PAGE_URI,
  PROTECTED_FALLBACK_PAGE_URI
 } from 'ngx-auth';
import { UiGeneralModule } from '../../ui-general/ui-general.module';
import { AuthenticationService } from './authentication.service';
import { FormsModule } from '@angular/forms';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CommonModule } from '@angular/common';
import { SignInPageComponent, SignOutPageComponent } from './pages';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';

export function factory(authenticationService: AuthenticationService) {
  return authenticationService;
}

@NgModule({
  declarations: [
    SignInPageComponent,
    SignOutPageComponent,
  ],
  imports: [
    AuthModule,
    UiGeneralModule,
    FormsModule,
    AngularFontAwesomeModule,
    CommonModule,
    LoadingBarHttpClientModule
    ],
  providers: [
    AuthenticationService,
    { provide: PROTECTED_FALLBACK_PAGE_URI, useValue: '/map' },
    { provide: PUBLIC_FALLBACK_PAGE_URI, useValue: '/sign-in' },
    {
      provide: AUTH_SERVICE,
      deps: [ AuthenticationService ],
      useFactory: factory
    }
  ]
})
export class AuthenticationModule { }



// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication.module.ts